"use client";

import { c as _c } from "react/compiler-runtime";
import type { ShortcutId, ShortcutPlatform } from "./shortcuts";
import * as React from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { shortcutHotkeys, shortcutKeycaps } from "./shortcuts";
type HotkeysParameters = Parameters<typeof useHotkeys>;

/** Use to bind a registry shortcut; options and dependencies pass through to react-hotkeys-hook. */
export function useShortcut(id, callback, options, dependencies) {
  const $ = _c(2);
  let t0;
  if ($[0] !== id) {
    t0 = shortcutHotkeys(id);
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useHotkeys(t0, callback, options, dependencies);
}
const subscribeToPlatform = () => () => undefined;
const getPlatform = (): ShortcutPlatform => /Mac|iPhone|iPad|iPod/.test(navigator.userAgent) ? "mac" : "other";
const getServerPlatform = (): ShortcutPlatform => "mac";

/** The keycaps for a registry shortcut on the viewer's platform. */
export function useShortcutKeycaps(id) {
  const $ = _c(3);
  const t0 = React.useSyncExternalStore(subscribeToPlatform, getPlatform, getServerPlatform);
  let t1;
  if ($[0] !== id || $[1] !== t0) {
    t1 = shortcutKeycaps(id, t0);
    $[0] = id;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}